// SPDX-License-Identifier: AGPL-3.0-or-later
import zipcodes from 'zipcodes';
export function lookupZip(zip) {
    const trimmed = zip.trim();
    if (!/^\d{5}$/u.test(trimmed))
        return null;
    const hit = zipcodes.lookup(trimmed);
    if (!hit || typeof hit.city !== 'string' || typeof hit.state !== 'string')
        return null;
    return { city: hit.city, state: hit.state };
}
//# sourceMappingURL=zip-lookup.js.map